import { CustomInputItemType, CustomInputStateMap } from '../type/common.type';

// 커스텀 텍스트 옵션 값 추출
export const getCustomInputValues = (customInputOptions: CustomInputStateMap) => {
  const values: CustomInputItemType[] = [];
  customInputOptions.forEach((inputState, name) => {
    if (inputState.value) {
      values.push({ [name]: inputState.value });
    }
  });
  return values;
};

// 필수 필드 입력 여부 확인
export const checkRequiredFieldsFilled = (customInputOptions: CustomInputStateMap) => {
  return Array.from(customInputOptions.values())
    .filter((inputState) => inputState.isRequired)
    .every((inputState) => inputState.value);
};

export const checkAllFieldsFilled = (customInputOptions: CustomInputStateMap) => {
  return Array.from(customInputOptions.values()).every((inputState) => inputState.value);
};
